import "@earendil-works/pi-codemode/worker";
